<template>
    <add-edit-project></add-edit-project>
</template>

<script>
import AddEditProject from "@/layouts/components/projects/addedit-project.vue";


export default {
 components : {
   AddEditProject
 },
};
</script>